import React from "react";
import PropTypes from "prop-types";
import { IonButton } from "@ionic/react";

function SelectPlayerPhase({ allPlayers, selectServicePlayer }) {
  return (
    <div
      className="ion-padding"
      style={{
        display: "flex",
        flexDirection: "column",
        maxWidth: "350px",
        textAlign: "center",
        justifyContent: "center",
        margin: "0 auto",
      }}
    >
      {allPlayers.map((player) => (
        <IonButton
          key={player.athleteId}
          size="large"
          expand="full"
          onClick={() => selectServicePlayer(player.athleteId)}
        >
          {player.name}
        </IonButton>
      ))}
    </div>
  );
}

SelectPlayerPhase.propTypes = {
  allPlayers: PropTypes.arrayOf(
    PropTypes.shape({
      athleteId: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
    }),
  ).isRequired,
  selectServicePlayer: PropTypes.func.isRequired,
};

export default SelectPlayerPhase;
